import { render } from "./AddDocument.vue?vue&type=template&id=25ecda7d&ts=true"
import script from "./AddDocument.ts?vue&type=script&lang=ts&external"
export * from "./AddDocument.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__